module.exports = __webpack_public_path__ + "img/le-point-logo-svg-vector.bbe0fcaf.svg";